const normalize = (value) => String(value || '').trim().toLowerCase();

function selectedVariantOption(sectionId, optionName) {
  const picker = document.querySelector(`variant-picker[data-section-id="${CSS.escape(sectionId)}"]`);
  if (!picker) return '';

  const wanted = normalize(optionName);
  const checked = Array.from(picker.querySelectorAll('input[data-option-name]:checked')).find(
    (input) => normalize(input.dataset.optionName) === wanted
  );
  if (checked) return checked.value;

  const select = Array.from(picker.querySelectorAll('select')).find((item) => {
    const option = item.selectedOptions?.[0];
    return normalize(option?.dataset.optionName) === wanted || normalize(item.name) === normalize(`options[${optionName}]`);
  });
  return select?.value || '';
}

function updateConditionalWrapper(wrapper) {
  const optionName = wrapper.dataset.kmShowOption;
  if (!optionName) return;

  const allowedValues = String(wrapper.dataset.kmShowValues || '')
    .split(',')
    .map(normalize)
    .filter(Boolean);
  const currentValue = normalize(selectedVariantOption(wrapper.dataset.kmSectionId, optionName));
  const visible = allowedValues.length === 0 || allowedValues.includes(currentValue);

  wrapper.hidden = !visible;
  wrapper.querySelectorAll('input, select, textarea').forEach((input) => {
    input.disabled = !visible;
    if (input.dataset.kmRequired === 'true' || wrapper.dataset.kmRequired === 'true') {
      input.required = visible;
      input.setAttribute('aria-required', visible ? 'true' : 'false');
    }
  });
}

function updateAllConditionalOptions() {
  document.querySelectorAll('[data-km-option-wrapper]').forEach(updateConditionalWrapper);
}

function updateCollapsibleLabel(wrapper) {
  const output = wrapper.querySelector('[data-km-selected-label]');
  if (!output) return;

  const checked = wrapper.querySelector('input[type="radio"]:checked');
  const selectedChoice = checked?.closest('[data-km-choice-label]');
  if (selectedChoice?.dataset.kmChoiceLabel) {
    output.textContent = selectedChoice.dataset.kmChoiceLabel;
  }
}

class KmOptionSelector extends HTMLElement {
  connectedCallback() {
    updateConditionalWrapper(this);
    updateCollapsibleLabel(this);
  }
}

if (!customElements.get('km-option-selector')) {
  customElements.define('km-option-selector', KmOptionSelector);
}

document.addEventListener('change', (event) => {
  const optionSelector = event.target.closest('km-option-selector');
  if (optionSelector) {
    updateCollapsibleLabel(optionSelector);
  }

  if (!event.target.closest('variant-picker')) return;
  requestAnimationFrame(updateAllConditionalOptions);
  window.setTimeout(updateAllConditionalOptions, 120);
});

requestAnimationFrame(updateAllConditionalOptions);
